import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "../lib/api";
import { ProductCard } from "../components/ProductCard";
import { Marquee } from "../components/Marquee";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="pt-16" data-testid="shop-page">
      <section className="spotlight mx-auto max-w-7xl px-5 pb-16 pt-20 sm:px-8">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          <div className="font-mono text-[11px] tracking-[0.3em] text-[#E8E9EB]">FULL CATALOG</div>
          <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl" data-testid="shop-heading">
            Shop Products
          </h1>
          <p className="mt-4 max-w-xl text-base text-slate-400">
            Bio-engineered formulations. Each batch independently verified by HPLC and mass spectrometry,
            with a Certificate of Analysis for every vial.
          </p>
          <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-[#6E7683]/40 bg-[#0B101D]/70 px-4 py-1.5 font-mono text-[10px] tracking-[0.25em] text-[#E8E9EB]" data-testid="aud-price-note">
            ALL PRICES IN AUD
          </div>
        </motion.div>
      </section>

      <Marquee />

      <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8">
        {loading ? (
          <p className="py-20 text-center font-mono text-xs tracking-[0.3em] text-slate-500" data-testid="shop-loading">LOADING FORMULATIONS...</p>
        ) : (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="product-grid">
            {products.map((p, i) => (
              <ProductCard key={p.id} product={p} index={i} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
